// extracted by mini-css-extract-plugin
export default {"wrap":"jG-z","fullWidth":"kG-z","hideOnDesktop":"lG-z","content":"mG-z","hasOpenedNav":"nG-z","crumbsList":"oG-z","dropdownsWrap":"pG-z"};